import { createReducer } from 'typesafe-actions';
import cartReducer, { defaultState as defaultCartState } from '../cart/reducers';
import { cartActions, CartActionType } from '../cart/actions';
import { CartState } from '../cart/types';
import productsWishlistReducer, { defaultState as defaultProductWishlistState } from '../productsWishlist/reducers';
import { actions as productWishlistActionsObject, ProductsWishlistActionType } from '../productsWishlist/actions';
import { ProductsWishlistState } from '../productsWishlist/types';
import looksWishlistReducer, { looksWishlistDefaultState } from '../looksWishlist/reducers';
import { actions as looksWishlistActionsObject, LooksWishlistActionType } from '../looksWishlist/actions';
import { LooksWishlistState } from '../looksWishlist/types';
import { IDSDropdownState } from '../idsDropdown/types';
import idsDropdownReducer, { defaultIdsDropdownState } from '../idsDropdown/reducer';
import { idsDropdownActions, IDSDropdownActionType } from '../idsDropdown/actions';
import idsFlyoutReducer, { defaultIdsFlyoutState } from '../idsFlyout/reducer';
import { idsFlyoutActions } from '../idsFlyout/actions';
import { IDSFlyoutState } from '../idsFlyout/types';
import { OverlaysState } from './overlays/types';
import { overlayActions, OverlayActionTypes } from './overlays/actions';
import overlayReducer from './overlays/reducers';
import { HeaderBarBannerState } from './headerBarBanner/types';
import headerBarBannerReducer, { defaultState as defaultHeaderBarBannerState } from './headerBarBanner/reducer';
import {
    splitHeaderBarBannerActions as headerBarBannerActions,
    HeaderBarBannerActionTypes,
} from './headerBarBanner/actions';
import { HeaderActionTypes, setDefaultHeaderState } from './actions';
import { defaultLooksState, looksHeaderReducer } from './headerLooksFlyout/reducer';
import { HeaderLooksState } from 'Client/redux/header/headerLooksFlyout/types';
import { LooksHeaderActionsType, splitFetchLooksHeaderActions } from 'Client/redux/header/headerLooksFlyout/actions';

type HeaderState = {
    cart: CartState;
    headerBarBanner: HeaderBarBannerState;
    productsWishlist: ProductsWishlistState;
    looksWishlist: LooksWishlistState;
    idsDropdown: IDSDropdownState;
    idsFlyout: IDSFlyoutState;
    looksFlyout: HeaderLooksState;
    overlays: OverlaysState;
};

export const defaultHeaderState = {
    cart: defaultCartState,
    headerBarBanner: defaultHeaderBarBannerState,
    productsWishlist: defaultProductWishlistState,
    looksWishlist: looksWishlistDefaultState,
    idsDropdown: defaultIdsDropdownState,
    looksFlyout: defaultLooksState,
    idsFlyout: defaultIdsFlyoutState,
    overlays: { byIds: {} },
};

export type CombineHeaderActions =
    | CartActionType
    | HeaderBarBannerActionTypes
    | ProductsWishlistActionType
    | LooksWishlistActionType
    | HeaderActionTypes
    | IDSDropdownActionType
    | LooksHeaderActionsType
    | OverlayActionTypes;

const headerReducer = createReducer<HeaderState, CombineHeaderActions>(defaultHeaderState)
    .handleAction(splitFetchLooksHeaderActions, (state, action) => {
        return { ...state, looksFlyout: looksHeaderReducer(state.looksFlyout, action) };
    })
    .handleAction(idsDropdownActions, (state, action) => {
        return { ...state, idsDropdown: idsDropdownReducer(state.idsDropdown, action) };
    })
    .handleAction(idsFlyoutActions, (state, action) => {
        return { ...state, idsFlyout: idsFlyoutReducer(state.idsFlyout, action) };
    })
    .handleAction(cartActions, (state, action) => {
        return { ...state, cart: cartReducer(state.cart, action) };
    })
    .handleAction(headerBarBannerActions, (state, action) => {
        return { ...state, headerBarBanner: headerBarBannerReducer(state.headerBarBanner, action) };
    })
    .handleAction(Object.values(productWishlistActionsObject), (state, action) => {
        return { ...state, productsWishlist: productsWishlistReducer(state.productsWishlist, action) };
    })
    .handleAction(Object.values(looksWishlistActionsObject), (state, action) => {
        return { ...state, looksWishlist: looksWishlistReducer(state.looksWishlist, action) };
    })
    .handleAction(Object.values(overlayActions), (state, action) => {
        return { ...state, overlays: overlayReducer(state.overlays, action) };
    })
    .handleAction(setDefaultHeaderState, () => {
        return { ...defaultHeaderState };
    });
export default headerReducer;
